<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="commitDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Write a Commit Message</div
  >

  <div *ngIf="isSessionRepo" class="text-s1 mt-4 text-base">
    Session will be archived after commit.
  </div>

  <form
    class="flex w-full flex-col"
    [formGroup]="commitForm"
    (ngSubmit)="commit()"
  >
    <input
      spellcheck="false"
      autocomplete="off"
      #commitMessage
      data-cy="commitDialogMessageInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          commitForm.controls['message'].invalid &&
          commitForm.controls['message'].touched
      }"
      formControlName="message"
      placeholder="Commit message"
    />
    <m-validation [control]="commitForm.controls['message']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="commitDialogCommitButton"
        class="bg-m600 text-m0 w-28 rounded py-3 font-medium focus:outline-none"
        type="submit"
        >Commit</button
      >

      <button
        data-cy="commitDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
